import http from '@/utils/http'
import service from '@/utils/service'
// 保存健康证
export const saveHealth = (data: any): any => http.post(`/hrm/health`, data)
// 删除健康证
export const deleteHrmHealth = (data: any): any =>
  service<any>({ method: 'delete', url: '/hrm/healths', data })
// 员工健康证
export const healthsEmployee = (data: any): any => http.post(`/hrm/employee/healths`, data)
